import { render, staticRenderFns } from "./AccountDetectModal.vue?vue&type=template&id=530ac50f&"
import script from "./AccountDetectModal.vue?vue&type=script&lang=js&"
export * from "./AccountDetectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports